import axios from 'axios';
import { BASE_URL_API } from './conf';

const api = axios.create({
  baseURL: BASE_URL_API,
});

api.defaults.validateStatus = code => code < 500

export default api;